export default __webpack_public_path__ + "static/media/supper_apps_background_m2.aec21456.jpg";